import { render, staticRenderFns } from "./inspection-feedback.vue?vue&type=template&id=c4e4ecc0&scoped=true&"
import script from "./inspection-feedback.vue?vue&type=script&lang=js&"
export * from "./inspection-feedback.vue?vue&type=script&lang=js&"
import style0 from "./inspection-feedback.vue?vue&type=style&index=0&id=c4e4ecc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e4ecc0",
  null
  
)

export default component.exports